import { ApiClient, ApiError } from '@color/lib';
import { useQuery } from '@tanstack/react-query';

const SAMPLE_SEARCH_URL = '/api/v1/sample_search';

export interface SampleSearchHit {
  _id: string;
  score?: number;
  norm_score?: number;
  batch_id?: string;
  sample_id?: string;
  kit_barcode?: string;
  sequenced_at?: string | null;
}

export interface SampleSearchResponse {
  took: number;
  hits: {
    total: number;
    hits: SampleSearchHit[];
  };
  headers: string[];
}

export interface SampleSearchParams {
  batch_label?: string;
  ssr_barcode?: string;
  kit_barcode?: string;
}

/**
 * Run a similarity search for a single sample sequence run identified by any of
 * batch name, sample name, or kit barcode. The backend requires at least one of
 * those, so the query is only enabled once a search has been submitted (`params`
 * is non-null). `retry` is disabled so a 400 (e.g. "More than one sample run
 * matches") surfaces immediately instead of being retried.
 */
export const useSampleSearchQuery = (params: SampleSearchParams | null) =>
  useQuery<SampleSearchResponse, ApiError>({
    queryKey: [SAMPLE_SEARCH_URL, params],
    queryFn: (): Promise<SampleSearchResponse> =>
      ApiClient.get(SAMPLE_SEARCH_URL, { params: { ...params } }),
    enabled: params !== null,
    retry: false,
  });
